import React, {Component} from 'react'

class CheckBoxInput extends Component {

    async componentDidMount(){
        for(let i = 0; i < this.props.value.length; i++){
            for(let j = 0; j < this.props.data.length; j++){
                if(this.props.value[i] === this.props.data[j]._id){
                    this.props.data[j].initialChecked = true
                }
            }
        }
        this.setState({justSet: true})
    }

    async onChange(e, data){
        this.props.onChange({preventDefault: e.preventDefault, target:{value: data._id}}, this.props.stateProp)
    }

    lookIfChecked(id){
        if(id === this.props.value){
            return true
        }
        return false
    }

    render(){
        return (
            <React.Fragment>
                <label className="checkBox-label"><strong>{this.props.baslik}</strong></label><hr style={{margin: 0}}></hr>
                {this.props.data.map(data => {
                    return (
                        <label className="col-lg-3 col-sm-12" >
                            <input className="input-checkbox" name={this.props.stateProp} checked={this.lookIfChecked(data._id)} type="radio" onChange={(e) => this.onChange(e, data)} />
                            <label style={this.props.stateProp == "color" ? {backgroundColor: data.color}: {}} className="data-label">{data.labelStrong}</label>
                        </label>
                    )
                })}
            </React.Fragment>
        )
    }  
}
export default CheckBoxInput